// extracted by mini-css-extract-plugin
export default {"replayStats":"ReplayStats_replayStats__3ft0t","subTable":"ReplayStats_subTable__9fYDB"};